import { ElementType } from "react";

import type { Size, Variant } from "./types";

export const sizes = ["sm", "md", "lg"] as const;
export const variants = ["outline", "primary", "text"] as const;

export const DEFAULT_SIZE = "md" satisfies Size;
export const DEFAULT_VARIANT = "outline" satisfies Variant;
export const DEFAULT_ELEMENT_TYPE = "button" satisfies ElementType;
